import "./src/styles/global.css"

export const onRouteUpdate = ({ location }: { location: Location }) => {
  if (!location.hash) {
    window.scrollTo(0, 0)
  }
}
